module.exports = __webpack_public_path__ + "static/img/pic_jizhengzm@2x.96ca4ad9.png";